export function getdata() {
	var obj = {
		headDataI: [{
				title: "税（费）种",
				prop: "title",
				width: "190px",
				custom: true,
			},
			{
				title: "栏次",
				prop: "grade",
				width: "100px",
				custom: true
			},
			{
				title: "计税（费）依据",
				prop: "",
				children: [{
						title: "增值税税额",
						prop: "",align:'right',
						children: [{
							title: "1",align:'right',
							prop: "zzs_5_x_1",
							custom: true,
							width: "110px",
						}, ]
					},
					{
						title: "增值税限额减免金额",
						prop: "",align:'right',
						children: [{
							title: "2",align:'right',
							prop: "zzs_5_x_2",
							custom: true,
							width: "110px",
						}, ]
					},
					{
						title: "增值税免抵税额",
						prop: "",align:'right',
						children: [{
							title: "3",align:'right',
							prop: "zzs_5_x_3",
							custom: true,
							width: "120px",
						}, ]
					},
					{
						title: "留抵退税本期扣除额",
						prop: "",align:'right',
						children: [{
							title: "4",align:'right',
							prop: "zzs_5_x_4",
							custom: true,
							width: "120px",
						}, ]
					}
				]
			},
			{
				title: "税（费）率（%）",
				prop: "",
				children: [{
					title: "",
					prop: "zzs_5_x_5",
					children: [{
						title: "5",align:'right',
						prop: "zzs_5_x_5",
						custom: true,
						width: "120px",
					}, ],
				}, ],
				custom: true,
			},
			{
				title: "本期应纳税（费）额",
				prop: "",
				children: [{
					title: "",
					prop: "",
					custom: true,
					width: "120px",
					children: [{
						title: "6=（1+2+3-4）×5",align:'right',
						prop: "zzs_5_x_6",
						custom: true,
						width: "120px",
					}, ],
				}, ],
			},
			{
				title: "本期减免税（费）额",
				prop: "",
				children: [{
						title: "减免性质代码",
						prop: "",
						custom: true,
						width: "120px",
						children: [{
							title: "7",
							prop: "zzs_5_x_7",
							custom: true,
							width: "120px",
						}, ],
					},
					{
						title: "减免税（费）额",
						prop: "",
						custom: true,
						width: "120px",align:'right',
						children: [{
							title: "8",align:'right',
							prop: "zzs_5_x_8",
							custom: true,
							width: "120px",
						}, ],
					},
				],
			},
			{
				title: "小微企业“六税两费”减征政策",
				prop: "",
				children: [{
						title: "减征比例（%）",
						prop: "",
						custom: true,align:'right',
						width: "120px",
						children: [{
							title: "9",align:'right',
							prop: "zzs_5_x_9",
							custom: true,
							width: "120px",
						}, ],
					},
					{
						title: "减征额",
						prop: "",
						custom: true,
						width: "120px",align:'right',
						children: [{
							title: "10",
							prop: "zzs_5_x_10",
							custom: true,align:'right',
							width: "120px",
						}, ],
					},
				],
			},
			{
				title: "试点建设培育产教融合型企业",
				prop: "",
				children: [{
						title: "减免性质代码",
						prop: "",
						custom: true,
						width: "220px",
						children: [{
							title: "11",
							prop: "zzs_5_x_11",
							custom: true,
							width: "220px",
						}, ],
					},
					{
						title: "本期抵免金额",
						prop: "",
						custom: true,
						width: "120px",align:'right',
						children: [{
							title: "12",align:'right',
							prop: "zzs_5_x_12",
							custom: true,
							width: "120px",
						}, ],
					},
				],
			},
			{
				title: "本期已缴税（费）额",
				prop: "",
				children: [{
					title: "",
					prop: "",
					custom: true,
					width: "120px",
					children: [{
						title: "13",align:'right',
						prop: "zzs_5_x_13",
						custom: true,
						width: "120px",
					}, ],
				}, ],
			},
			{
				title: "本期应补（退）税（费）额",
				prop: "",
				children: [{
					title: "",
					prop: "",
					custom: true,
					width: "120px",align:'right',
					children: [{
						title: "14=6-8-10-12-13",
						prop: "zzs_5_x_14",align:'right',
						custom: true,
						width: "120px",
					}, ],
				}, ],
			},

		],
		headDataII: [{
			title: "分支机构附加税费情况表",
			children: [{
				title: "分支机构纳税人识别号",
				prop: "zzs_5_x_1",
				width: "190px",
				custom: true,
			}, {
				title: "分支机构名称",
				prop: "zzs_5_x_2",
				width: "190px",
				custom: true,
			}, {
				title: "征收项目",
				prop: "zzs_5_x_3",
				width: "190px",
				custom: true,
			}, {
				title: "征收品目",
				prop: "zzs_5_x_4",
				width: "190px",
				custom: true,
			}, {
				title: "计税依据",
				prop: "zzs_5_x_5",
				width: "190px",
				custom: true,
			}, {
				title: "税率",
				prop: "zzs_5_x_6",
				width: "190px",
				custom: true,
			}, {
				title: "本期应补（退）税额",
				prop: "zzs_5_x_7",
				width: "190px",
				custom: true,
			}, ]
		}, ],
		tableDataIII: [{
				disabledzzs_5_x_1: true,
				disabledzzs_5_x_2: true,
				disabledzzs_5_x_3: true,
				disabledzzs_5_x_4: true,
				disabledzzs_5_x_5: true,
				disabledzzs_5_x_6: false,
				disabledzzs_5_x_7: true,
				zzs_5_x_1: {
					cellCode:"zzs_5_11a_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				zzs_5_x_2: {
					cellCode:"zzs_5_11a_2",
					cellType:"1",
					cellVal:"240040043.08"
				},
				zzs_5_x_3: {
					cellCode:"zzs_5_11a_3",
					cellType:"1",
					cellVal:"240040043.08"
				},
				zzs_5_x_4: {
					cellCode:"zzs_5_11a_4",
					cellType:"1",
					cellVal:"240040043.08"
				},
				zzs_5_x_5: {
					cellCode:"zzs_5_11a_5",
					cellType:"1",
					cellVal:"240040043.08"
				},
				zzs_5_x_6: {
					cellCode:"zzs_5_11a_6",
					cellType:"1",
					cellVal:"240040043.08"
				},
				zzs_5_x_7: {
					cellCode:"zzs_5_11a_7",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},
			{
				disabledzzs_5_x_1: true,
				disabledzzs_5_x_2: true,
				disabledzzs_5_x_3: true,
				disabledzzs_5_x_4: true,
				disabledzzs_5_x_5: true,
				disabledzzs_5_x_6: false,
				disabledzzs_5_x_7: true,
				zzs_5_x_1: {
					cellCode:"zzs_5_11b_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				zzs_5_x_2: {
					cellCode:"zzs_5_11b_2",
					cellType:"1",
					cellVal:"240040043.08"
				},
				zzs_5_x_3: {
					cellCode:"zzs_5_11b_3",
					cellType:"1",
					cellVal:"240040043.08"
				},
				zzs_5_x_4: {
					cellCode:"zzs_5_11b_4",
					cellType:"1",
					cellVal:"240040043.08"
				},
				zzs_5_x_5: {
					cellCode:"zzs_5_11b_5",
					cellType:"1",
					cellVal:"240040043.08"
				},
				zzs_5_x_6: {
					cellCode:"zzs_5_11b_6",
					cellType:"1",
					cellVal:"240040043.08"
				},
				zzs_5_x_7: {
					cellCode:"zzs_5_11b_7",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},
			{
				disabledzzs_5_x_1: true,
				disabledzzs_5_x_2: true,
				disabledzzs_5_x_3: true,
				disabledzzs_5_x_4: true,
				disabledzzs_5_x_5: true,
				disabledzzs_5_x_6: false,
				disabledzzs_5_x_7: true,
				zzs_5_x_1: {
					cellCode:"zzs_5_11c_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				zzs_5_x_2: {
					cellCode:"zzs_5_11c_2",
					cellType:"1",
					cellVal:"240040043.08"
				},
				zzs_5_x_3: {
					cellCode:"zzs_5_11c_3",
					cellType:"1",
					cellVal:"240040043.08"
				},
				zzs_5_x_4: {
					cellCode:"zzs_5_11c_4",
					cellType:"1",
					cellVal:"240040043.08"
				},
				zzs_5_x_5: {
					cellCode:"zzs_5_11c_5",
					cellType:"1",
					cellVal:"240040043.08"
				},
				zzs_5_x_6: {
					cellCode:"zzs_5_11c_6",
					cellType:"1",
					cellVal:"240040043.08"
				},
				zzs_5_x_7: {
					cellCode:"zzs_5_11c_7",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				disabledzzs_5_x_1: true,
				disabledzzs_5_x_2: true,
				disabledzzs_5_x_3: true,
				disabledzzs_5_x_4: true,
				disabledzzs_5_x_5: true,
				disabledzzs_5_x_6: false,
				disabledzzs_5_x_7: true,
				zzs_5_x_1: {
					cellCode:"zzs_5_12a_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				zzs_5_x_2: {
					cellCode:"zzs_5_12a_2",
					cellType:"1",
					cellVal:"240040043.08"
				},
				zzs_5_x_3: {
					cellCode:"zzs_5_12a_3",
					cellType:"1",
					cellVal:"240040043.08"
				},
				zzs_5_x_4: {
					cellCode:"zzs_5_12a_4",
					cellType:"1",
					cellVal:"240040043.08"
				},
				zzs_5_x_5: {
					cellCode:"zzs_5_12a_5",
					cellType:"1",
					cellVal:"240040043.08"
				},
				zzs_5_x_6: {
					cellCode:"zzs_5_12a_6",
					cellType:"1",
					cellVal:"240040043.08"
				},
				zzs_5_x_7: {
					cellCode:"zzs_5_12a_7",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				disabledzzs_5_x_1: true,
				disabledzzs_5_x_2: true,
				disabledzzs_5_x_3: true,
				disabledzzs_5_x_4: true,
				disabledzzs_5_x_5: true,
				disabledzzs_5_x_6: false,
				disabledzzs_5_x_7: true,
				zzs_5_x_1: {
					cellCode:"zzs_5_12b_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				zzs_5_x_2: {
					cellCode:"zzs_5_12b_2",
					cellType:"1",
					cellVal:"240040043.08"
				},
				zzs_5_x_3: {
					cellCode:"zzs_5_12b_3",
					cellType:"1",
					cellVal:"240040043.08"
				},
				zzs_5_x_4: {
					cellCode:"zzs_5_12b_4",
					cellType:"1",
					cellVal:"240040043.08"
				},
				zzs_5_x_5: {
					cellCode:"zzs_5_12b_5",
					cellType:"1",
					cellVal:"240040043.08"
				},
				zzs_5_x_6: {
					cellCode:"zzs_5_12b_6",
					cellType:"1",
					cellVal:"240040043.08"
				},
				zzs_5_x_7: {
					cellCode:"zzs_5_12b_7",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				disabledzzs_5_x_1: true,
				disabledzzs_5_x_2: true,
				disabledzzs_5_x_3: true,
				disabledzzs_5_x_4: true,
				disabledzzs_5_x_5: true,
				disabledzzs_5_x_6: false,
				disabledzzs_5_x_7: true,
				zzs_5_x_1: {
					cellCode:"zzs_5_12c_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				zzs_5_x_2: {
					cellCode:"zzs_5_12c_2",
					cellType:"1",
					cellVal:"240040043.08"
				},
				zzs_5_x_3: {
					cellCode:"zzs_5_12c_3",
					cellType:"1",
					cellVal:"240040043.08"
				},
				zzs_5_x_4: {
					cellCode:"zzs_5_12c_4",
					cellType:"1",
					cellVal:"240040043.08"
				},
				zzs_5_x_5: {
					cellCode:"zzs_5_12c_5",
					cellType:"1",
					cellVal:"240040043.08"
				},
				zzs_5_x_6: {
					cellCode:"zzs_5_12c_6",
					cellType:"1",
					cellVal:"240040043.08"
				},
				zzs_5_x_7: {
					cellCode:"zzs_5_12c_7",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},
		],
		tableDataII: [{},
			{},
			{},
			{},
			{},
			{},
			{}
		],
		tableDataI: [{
				title: "城市维护建设税",
				grade: "1",
				disabledzzs_5_x_1: true,
				disabledzzs_5_x_4: true,
				disabledzzs_5_x_6: true,
				disabledzzs_5_x_9: true,
				disabledzzs_5_x_10: true,
				disabledzzs_5_x_11: true,
				disabledzzs_5_x_12: true,
				disabledzzs_5_x_14: true,
				zzs_5_x_1: {
					cellVal: ""
				},
				zzs_5_x_2: {
					cellVal: ""
				},
				zzs_5_x_3: {
					cellVal: ""
				},
				zzs_5_x_4: {
					cellVal: ""
				},
				zzs_5_x_5: {
					cellVal: ""
				},
				zzs_5_x_6: {
					cellVal: ""
				},
				zzs_5_x_7: {
					cellVal: ""
				},
				zzs_5_x_8: {
					cellVal: ""
				},
				zzs_5_x_9: {
					cellVal: ""
				},
				zzs_5_x_10: {
					cellVal: ""
				},
				zzs_5_x_11: {
					cellVal: ""
				},
				zzs_5_x_12: {
					cellVal: ""
				},
				zzs_5_x_13: {
					cellVal: ""
				},
				zzs_5_x_14: {
					cellVal: ""
				},
			},
			{
				title: "教育费附加",
				grade: "2",
				disabledzzsse: true,
				disabledzzs_5_x_1: true,
				disabledzzs_5_x_4: true,
				disabledzzs_5_x_6: true,
				disabledzzs_5_x_9: true,
				disabledzzs_5_x_10: true,
				disabledzzs_5_x_14: true,
				zzs_5_x_1: {
					cellVal: ""
				},
				zzs_5_x_2: {
					cellVal: ""
				},
				zzs_5_x_3: {
					cellVal: ""
				},
				zzs_5_x_4: {
					cellVal: ""
				},
				zzs_5_x_5: {
					cellVal: ""
				},
				zzs_5_x_6: {
					cellVal: ""
				},
				zzs_5_x_7: {
					cellVal: ""
				},
				zzs_5_x_8: {
					cellVal: ""
				},
				zzs_5_x_9: {
					cellVal: ""
				},
				zzs_5_x_10: {
					cellVal: ""
				},
				zzs_5_x_11: {
					cellVal: ""
				},
				zzs_5_x_12: {
					cellVal: ""
				},
				zzs_5_x_13: {
					cellVal: ""
				},
				zzs_5_x_14: {
					cellVal: ""
				},
			},
			{
				title: "地方教育附加",
				grade: "3",
				disabledzzsse: true,
				disabledzzs_5_x_1: true,
				disabledzzs_5_x_4: true,
				disabledzzs_5_x_9: true,
				disabledzzs_5_x_10: true,
				disabledzzs_5_x_6: true,
				disabledzzs_5_x_14: true,
				zzs_5_x_1: {
					cellVal: ""
				},
				zzs_5_x_2: {
					cellVal: ""
				},
				zzs_5_x_3: {
					cellVal: ""
				},
				zzs_5_x_4: {
					cellVal: ""
				},
				zzs_5_x_5: {
					cellVal: ""
				},
				zzs_5_x_6: {
					cellVal: ""
				},
				zzs_5_x_7: {
					cellVal: ""
				},
				zzs_5_x_8: {
					cellVal: ""
				},
				zzs_5_x_9: {
					cellVal: ""
				},
				zzs_5_x_10: {
					cellVal: ""
				},
				zzs_5_x_11: {
					cellVal: ""
				},
				zzs_5_x_12: {
					cellVal: ""
				},
				zzs_5_x_13: {
					cellVal: ""
				},
				zzs_5_x_14: {
					cellVal: ""
				},
			},
			{
				title: "合计",
				grade: "4",
				disabledzzs_5_x_1: true,
				disabledzzs_5_x_2: true,
				disabledzzs_5_x_3: true,
				disabledzzs_5_x_4: true,
				disabledzzs_5_x_5: true,
				disabledzzs_5_x_6: true,
				disabledzzs_5_x_7: true,
				disabledzzs_5_x_8: true,
				disabledzzs_5_x_9: true,
				disabledzzs_5_x_10: true,
				disabledzzs_5_x_11: true,
				disabledzzs_5_x_12: true,
				disabledzzs_5_x_13: true,
				disabledzzs_5_x_14: true,
				zzs_5_x_1: {
					cellVal: ""
				},
				zzs_5_x_2: {
					cellVal: ""
				},
				zzs_5_x_3: {
					cellVal: ""
				},
				zzs_5_x_4: {
					cellVal: ""
				},
				zzs_5_x_5: {
					cellVal: ""
				},
				zzs_5_x_6: {
					cellVal: ""
				},
				zzs_5_x_7: {
					cellVal: ""
				},
				zzs_5_x_8: {
					cellVal: ""
				},
				zzs_5_x_9: {
					cellVal: ""
				},
				zzs_5_x_10: {
					cellVal: ""
				},
				zzs_5_x_11: {
					cellVal: ""
				},
				zzs_5_x_12: {
					cellVal: ""
				},
				zzs_5_x_13: {
					cellVal: ""
				},
				zzs_5_x_14: {
					cellVal: ""
				},
			}
		]
	}
	return obj
}
